import { AgentApplicationsListModule } from '@/components/modules/AgentDetail/AgentApplicationsList/AgentApplicationsList';
import { AgentDetailsModule } from '@/components/modules/AgentDetail/AgentDetails/AgentDetails';
import { AgentUserListModule } from '@/components/modules/AgentDetail/AgentUserList/AgentUserList';
import { ProvidersDetailsModule } from '@/components/modules/AgentDetail/ProvidersDetails/ProvidersDetails';
import { MetricsAgentViewsModule } from '@/components/modules/Metrics/ChannelAgentMetricViews/MetricAgentViews';
import { PAGE_AGENT_ALLOWED_ROLES } from '@/components/views/DynamicPageView/config/layoutScheme/constants/PageAgentAllowedRoles';
import { DYNAMIC_PAGE_PATHS } from '@/components/views/DynamicPageView/config/shared/pathRoutes';
import { WIDGETS } from '@/components/views/DynamicPageView/config/shared/widgets';
import { APP_ROLES, APP_USER_TYPES } from '@/config/config';
import { PageScheme } from '@/config/types';

export const PAGE_AGENT: PageScheme = {
  path: DYNAMIC_PAGE_PATHS.AGENT,
  schemesByRoles: [
    {
      roles: PAGE_AGENT_ALLOWED_ROLES,
      titleTextId: 'AGENT',
      widgets: [
        {
          id: WIDGETS.AGENT_PAGE_TITLE,
          props: {},
          roles: PAGE_AGENT_ALLOWED_ROLES,
          notShownInRightMenu: true,
        },
        {
          id: WIDGETS.AGENT_DETAIL_ACTIONS_WIDGET,
          props: {},
          roles: [APP_ROLES.SUPER_ADMIN, APP_ROLES.ADMIN],
        },
      ],
    },
  ],
  sections: [
    {
      textId: 'AGENT_DETAILS',
      module: (
        <AgentDetailsModule
          permissions={{
            view: [APP_USER_TYPES.SUPER_ADMIN, APP_USER_TYPES.ADMIN, APP_USER_TYPES.PARTNER],
            edit: [APP_ROLES.SUPER_ADMIN, APP_ROLES.ADMIN], //TODO add editModeAllowed when request is ready in js-api-client
          }}
        />
      ),
    },
    {
      textId: 'USER_CREDENTIALS',
      module: (
        <AgentUserListModule
          permissions={{
            view: [APP_USER_TYPES.SUPER_ADMIN, APP_USER_TYPES.ADMIN, APP_USER_TYPES.MERCHANT_GROUP],
            edit: [APP_ROLES.SUPER_ADMIN, APP_ROLES.ADMIN],
          }}
        />
      ),
    },
    {
      textId: 'PROVIDERS_DETAILS',
      module: (
        <ProvidersDetailsModule
          permissions={{
            view: [APP_USER_TYPES.SUPER_ADMIN, APP_USER_TYPES.ADMIN],
            edit: [APP_ROLES.SUPER_ADMIN, APP_ROLES.ADMIN],
          }}
        />
      ),
    },
    {
      textId: 'AGENT_METRICS',
      module: (
        <MetricsAgentViewsModule
          permissions={{
            view: [
              APP_USER_TYPES.SUPER_ADMIN,
              APP_USER_TYPES.ADMIN,
              APP_USER_TYPES.MERCHANT,
              APP_USER_TYPES.CHANNEL,
              APP_USER_TYPES.AGENT,
              APP_USER_TYPES.MERCHANT_GROUP,
            ],
          }}
        />
      ),
    },
    {
      textId: 'APPLICATIONS_LIST',
      module: (
        <AgentApplicationsListModule
          permissions={{
            view: [
              APP_USER_TYPES.SUPER_ADMIN,
              APP_USER_TYPES.ADMIN,
              APP_USER_TYPES.MERCHANT,
              APP_USER_TYPES.CHANNEL,
              APP_USER_TYPES.MERCHANT_GROUP,
            ],
          }}
        />
      ),
    },
  ],
};
